import { useMutation, useQuery } from "@tanstack/react-query";
import { OrganizationDto } from "@common/dto/organization/organization.dto";
import { Organization } from "@common/types/organization";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { organizationContract } from "@common/contracts/organization.contract";
import { UnwrapOpaque } from "@ts-rest/core";

const organizationContractClient = getBackendAPIClient(organizationContract);

export async function fetchOrganizations(): Promise<Organization[]> {
    const result = await organizationContractClient.listOrganizations();
    return result.body.map(OrganizationDto.deserialize);
}

export const organizationQueryKeys = {
    all: () => ["organization"],
    list: () => [...organizationQueryKeys.all(), "list"],
} as const;

export function useOrganizations() {
    return useQuery({
        queryKey: organizationQueryKeys.list(),
        queryFn: async () => await fetchOrganizations(),
    });
}

type UpdateOrganizationPayload = UnwrapOpaque<
    typeof organizationContract.updateOrganization.body
>;

export interface UpdateOrganizationParams {
    organizationId: string;
    payload: UpdateOrganizationPayload;
}

export function useUpdateOrganizationMutation() {
    return useMutation({
        mutationFn: async ({
            organizationId,
            payload,
        }: UpdateOrganizationParams) => {
            await organizationContractClient.updateOrganization({
                params: { organizationId },
                body: payload,
            });
        },
    });
}
